import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  logInUserDetail: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setlogInUserDetail: (state, action) => {
      state.logInUserDetail = action.payload;
    },
    deletelogInUserDetail: (state, action) => {
      state.logInUserDetail = null;
    },
    deleteUser: (state, action) => {
      state.user = null;
    },
  },
});

export const {
  setUser,
  deleteUser,
  setlogInUserDetail,
  deletelogInUserDetail,
} = authSlice.actions;

export default authSlice.reducer;
